import React, { Component } from "react";
import PropTypes from "prop-types";
import { Button, Dimmer, Header } from "semantic-ui-react";
import TracksWithVotesList from "../VotifyQueue/TracksWithVotesList";

class SearchResults extends Component {
  constructor(props) {
    super(props);
    this.resultsCompare = this.resultsCompare.bind(this);
  }

  resultsCompare(a, b) {
    return a.offset * 1000 - a.popularity;
  }

  render() {
    if (this.props.results) {
      return (
        <div>
          <Dimmer.Dimmable
            dimmed={this.props.isLoading && !this.props.results}
            blurring
          >
            <TracksWithVotesList
              showImages
              participantVotes={this.props.participantVotes}
              tracks={this.props.results}
              clickVote={this.props.clickVote}
              votes={this.props.votes}
              compare={this.resultsCompare}
            />
            {this.props.isMore && (
              <Button
                onClick={this.props.getNextPage}
                content={"MORE"}
                color={"grey"}
                loading={this.props.isLoading}
                fluid
                inverted
                basic
              />
            )}
          </Dimmer.Dimmable>
        </div>
      );
    } else {
      return (
        <div>
          <Header as={"h3"}>No results</Header>
        </div>
      );
    }
  }
}

SearchResults.propTypes = {
  results: PropTypes.array.isRequired,
  participantVotes: PropTypes.object.isRequired,
  clickVote: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  getNextPage: PropTypes.func.isRequired,
  isMore: PropTypes.bool,
  votes: PropTypes.object,
};

export default SearchResults;
